import { HznCopyButton } from './copy-button/copy-button.js';
import { defineHorizonElement } from '@horizon/common/helpers';
import '@horizon/style/fonts/inject.js';
import './types.js';
defineHorizonElement('hzn-copy-button', HznCopyButton);
